import { Event } from 'main.core';

const BACKDROP_STYLES = {
	position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 997,
    width: '100vw',
    height: '100vh',
	backgroundColor: '#000',
	opacity: 0,
	transition: 'opacity 0.15s linear'
};

export default class Backdrop extends Event.EventEmitter
{
	#parent;
	#element;
	#css;

	static get Events()
	{
		return {
			SHOWN: 'shown',
			HIDDEN: 'hidden',
			CLICK: 'click'
		};
	}

	constructor(parent = document.body)
	{
		super();

		this.setEventNamespace('EShop24.Backdrop');

		this.#parent = parent;
		this.#css = { ...BACKDROP_STYLES };
		if(this.#parent !== document.body)
		{
			Object.assign(this.#css, {
				position: 'absolute',
				width: '100%',
				height: '100%'
			});
		}

		//this.#element = document.createElement('');
		//this.#parent.appendChild(this.#element);
	}

	get element()
	{
		return this.#element;
	}

	set zIndex(val)
	{
		this.#css.zIndex = val;

		if (this.#element)
			this.#element.style.zIndex = val;
	}

	show()
	{
		if (this.#element)
			return;

		this.#element = document.createElement('div');
		this.#parent.appendChild(this.#element);
		Object.assign(this.#element.style, this.#css);

		setTimeout(() => {
			this.#element.style.opacity = 0.5;
		});

		this.emit(Backdrop.Events.SHOWN);
		this.#element.addEventListener('click', () => {
			this.emit(Backdrop.Events.CLICK);
		});
	}

	hide()
	{
		if (!this.#element)
			return;

		this.#element.style.opacity = 0;
		this.#element.addEventListener('transitionend', () => {
			this.#element.remove();
			this.#element = null;

			this.emit(Backdrop.Events.HIDDEN);
		});
	}
}